import { render, staticRenderFns } from "./TicketTransportForm.vue?vue&type=template&id=5f16db72&scoped=true"
import script from "./TicketTransportForm.vue?vue&type=script&lang=ts"
export * from "./TicketTransportForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f16db72",
  null
  
)

export default component.exports